import AscImg1 from "../assets/AscImg1.jpg"
import AscImg2 from "../assets/AscImg2.jpg"
import AscImg3 from "../assets/AscImg3.jpg"
import AscImg4 from "../assets/AscImg4.jpg"
import AscImg5 from "../assets/AscImg5.jpg"
import AscImg6 from "../assets/AscImg6.jpg"
import AscImg7 from "../assets/AscImg7.jpg"
import AscImg8 from "../assets/AscImg8.jpg"
import AscImg9 from "../assets/AscImg9.jpg"
import AscImg10 from "../assets/AscImg10.jpg"
export const AccessoriesList =[
{
    id: "A1",
    name: "Naruto keychain ", 
    Price: 149,
    imgsrc:AscImg1,
},
{
    id: "A2",
    name: "Animoda Ring", 
    Price: 230,
    imgsrc:AscImg2,
},
{
    id: "A3",
    name: "Naruto Pendant", 
    Price: 200,
    imgsrc:AscImg3,
},
{
    id: "A4",
    name: "Naruto Doll", 
    Price: 850,
    imgsrc:AscImg4,
},
{
    id: "A5",
    name: "Itachi Keychain", 
    Price: 259,
    imgsrc:AscImg5,
},
{
    id: "A6",
    name: "Naruto Ring", 
    Price: 480,
    imgsrc:AscImg6,
},
{
    id: "A7",
    name: "Naruto Keychain", 
    Price: 150,
    imgsrc:AscImg7,
},
{
    id: "A8",
    name: "AOT Scarf", 
    Price: 450,
    imgsrc:AscImg8,
},
{
    id: "A9",
    name: "Animoda Sticker", 
    Price: 300,
    imgsrc:AscImg9,
},
{
    id: "PA0",
    name: "Gojo Bottle", 
    Price: 500,
    imgsrc:AscImg10,
},
];